module.exports = __webpack_public_path__ + "img/sel_Beijing.653f28b6.png";